// Init
import React from "react";
import { Route, Switch } from "react-router-dom";

// Routes
import Home from "../containers/Home.js";

const index = () => {
  return (
    <Switch>
      <Route exact path="/:token" component={Home} />
    </Switch>
  );
};

export default index;
